import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
  drawDOM,
  exportImage,
  exportPDF
} from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import {
  Chart,
  ChartArea,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTitle,
  ChartTooltip,
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";
import { Window } from "@progress/kendo-react-dialogs";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import "hammerjs";
import * as moment from "moment";
import React, { Component, PureComponent } from "react";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import AddToCart from "../Tenant/AddToCart";
import ViewActionRiskDataset from "./ViewActionRiskDataset";
import TextNarrative from "./TextNarrative";
import SkeletonReport from "./SkeletonReport";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";
export default class BarChartContainer extends Component {
  _chart;
  _MailId;
  _Message;
  _Loader = false;
  _Title;
  _expandFlag;
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      visible: false,
      isReportLoaded: false,
      chartData: {},
      isHidden: false,
    };

    this._exporterBarChart = React.createRef();
  }
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
        });
        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };
  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  onImageExportClick = () => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "bar-chart";

    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    
    // 4. Create a temporary white background overlay
    const whiteBackground = document.createElement('div');
    whiteBackground.style.position = 'absolute';
    whiteBackground.style.top = '0';
    whiteBackground.style.left = '0';
    whiteBackground.style.width = '100%';
    whiteBackground.style.height = '100%';
    whiteBackground.style.backgroundColor = 'white';
    whiteBackground.style.zIndex = '-1';
    
    // Store original position style
    const originalPosition = gridElement.style.position;
    
    // Make the container positioned so the absolute overlay works
    gridElement.style.position = 'relative';
    
    // Add the white background to the container
    gridElement.appendChild(whiteBackground);
    
    // 5. Create a style element with comprehensive white background rules
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Target the specific container */
      #${gridElement.id} {
        background-color: white !important;
        color: black !important;
        position: relative !important;
      }
      
      /* Target all elements inside the container */
      #${gridElement.id} * {
        background-color: white !important;
        color: black !important;
      }
      
      /* Specific targeting for the dataset header which appears to have a black background */
      #${gridElement.id} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target the text narrative area */
      #${gridElement.id} .textnarrativeexport {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .textnarrativeexport p {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target any potential dividers or borders */
      #${gridElement.id} hr,
      #${gridElement.id} .divider {
        background-color: white !important;
        border-color: white !important;
      }
      
      /* Preserve chart colors */
      #${gridElement.id} .mitigated { background-color: rgb(248, 220, 135) !important; }
      #${gridElement.id} .unmitigated { background-color: rgb(255, 138, 130) !important; }
      #${gridElement.id} .mitigatedend { background-color: rgb(223, 170, 10) !important; }
      #${gridElement.id} .umitigatedend { background-color: rgb(179, 27, 16) !important; }
      #${gridElement.id} .originalCompletionDate { background-color: rgb(206,237,248) !important; }
      #${gridElement.id} .projectedCompletionDate { background-color: rgb(227, 241, 22) !important; }
      #${gridElement.id} .actualCompletionDate { background-color: rgb(34,159,204) !important; }
      #${gridElement.id} .currentValue { background-color: rgb(8, 77, 167) !important; }
       #${gridElement.id} .currentValueEnd{background-color:rgb(45, 125, 230);}
    `;
    
    // Add the style element to the document head
    document.head.appendChild(styleElement);
    
    // 6. Export immediately
    drawDOM(gridElement, { background: "white" })
      .then((group) => exportImage(group, { background: "white" }))
      .then((dataURI) => {
        saveAs(dataURI, widgetName + ".png");
      })
      .finally(() => {
        // 7. Clean up - remove the white background overlay
        try {
          gridElement.removeChild(whiteBackground);
        } catch (e) {
          console.error("Error removing white background:", e);
        }
        
        // 8. Restore original position
        gridElement.style.position = originalPosition;
        
        // 9. Remove the style element
        try {
          document.head.removeChild(styleElement);
        } catch (e) {
          console.error("Error removing style element:", e);
        }
        
        // 10. Hide the narrative element again
        if (narrativeElement) {
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
  };
  onPDFExportClick = (flag) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);

    //================ Export Narrative Start =========================
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    //================ Export Narrative End ===========================

    //================ transparency Start ===========================

    // Function to recursively set background to transparent for all elements
    const makeTransparent = (element, originalStyles, prefix) => {
      // Store original background
      originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
      originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

      // Set background to transparent
      element.style.backgroundColor = "transparent";
      element.style.backgroundImage = "none";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        makeTransparent(child, originalStyles, `${prefix}_${index}`);
      });

      return originalStyles;
    };

    // Function to restore original backgrounds
    const restoreBackgrounds = (element, originalStyles, prefix) => {
      // Restore background
      element.style.backgroundColor = originalStyles[`${prefix}_bg`] || "";
      element.style.backgroundImage = originalStyles[`${prefix}_bgImg`] || "";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
      });
    };

    // Store original styles and make all elements transparent
    const originalStyles = {};
    makeTransparent(gridElement, originalStyles, "root");

    // Add a temporary style tag with aggressive selectors
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: transparent !important;
        background-image: none !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
          
   #${gridElement.id} .mitigated{background-color: rgb(248, 220, 135) !important;}
  #${gridElement.id} .unmitigated{background-color:rgb(255, 138, 130) !important;}
  #${gridElement.id} .mitigatedend{background-color:rgb(223, 170, 10) !important;}
  #${gridElement.id} .umitigatedend{background-color: rgb(179, 27, 16) !important;}
  #${gridElement.id} .originalCompletionDate{background-color: rgb(206,237,248) !important;}
  #${gridElement.id} .projectedCompletionDate{background-color: rgb(227, 241, 22) !important;}
  #${gridElement.id} .actualCompletionDate{background-color:rgb(34,159,204) !important;}  
  #${gridElement.id} .currentValue{background-color:rgb(8, 77, 167) !important;}
  #${gridElement.id} .currentValueEnd{background-color:rgb(45, 125, 230);}
      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
    document.head.appendChild(styleTag);

    // If this is a Kendo chart, try to update its options directly
    if (this._chart && typeof this._chart.setOptions === "function") {
      try {
        const currentOptions = this._chart.options || {};
        this._chart.setOptions({
          ...currentOptions,
          chartArea: {
            ...currentOptions.chartArea,
            background: "transparent",
          },
          plotArea: {
            ...currentOptions.plotArea,
            background: "transparent",
          },
        });
      } catch (e) {
        console.error("Error updating chart options:", e);
      }
    }

    // Force a repaint
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";
    //================ transparency End ===========================

    // setTimeout(async () => {
    drawDOM(gridElement, {
      // landscape: false,
      title: this.state.title + " " + CreatedDate,
      background: "transparent",
      // paperSize: "auto",
      // margin: "1cm",
      // scale: 0.8,
      // forcePageBreak: ".page-break",
    })
      .then((group) => {
        // Try to modify the group to ensure transparency
        try {
          if (group && group.children) {
            group.children.forEach((child) => {
              if (child.options) {
                child.options.background = "transparent";
              }
            });
          }
        } catch (e) {
          console.error("Error modifying group:", e);
        }

        return exportPDF(group, {
          background: "transparent",
        });
      })
      .then((dataURI) => {
        if (flag === "MAIL") {
          this.sendMail(dataURI, chartId);
        }else{
          saveAs(dataURI, widgetName + ".pdf");
        }
      })
      .catch((error) => {
        console.error("PDF export error:", error);
      })
      .finally(() => {
        // Clean up - remove the style tag
        document.head.removeChild(styleTag);

        // Restore original backgrounds
        restoreBackgrounds(gridElement, originalStyles, "root");

        // If we modified the chart options, try to restore them
        if (this._chart && typeof this._chart.setOptions === "function") {
          try {
            this._chart.refresh();
          } catch (e) {
            console.error("Error refreshing chart:", e);
          }
        }

        if (narrativeElement) {
          // 5. After export, remove the temporary text or hide the element
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
    // }, 1000);

    // this.pdfTitlePopupClose();
  };

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId || this.props.reportId,
      };
      this._Loader = true;
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this._Loader = false;
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this._Loader = false;
    }
  };

  changeLineChartWidth = (widgetId) => {
    this._expandFlag = true;
    this.props.changeLineChartWidth(widgetId);
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile = (widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    setTimeout(async () => {
      drawDOM(gridElement, {
        landscape: true,
        title: this.state.title + " " + CreatedDate,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataURI) => {
          this.sendMail(dataURI, widgetId);
        });
    }, 1000);
  };

  sendMail = async (dataURL, widgetId) => {
    try {
      this._Loader = true;
      let widgetName = this.state.chartData
        ? this.state.chartData.widgetName
        : "Bar-chart";
      const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

      var file = this.dataURLtoFile(dataURL, widgetName + ".pdf");
      var fd = new FormData(document.forms[0]);
      fd.append("file", file);
      fd.append("mailId", this._MailId);
      fd.append("message", this._Message);
      fd.append("widgetId", widgetId);
      fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
      fd.append("CreatedDate", CreatedDate);
      fd.append("name", secureLocalStorage.getItem("userName"));
      fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
      let response = await Api.shareWidgetToUser(fd);
      if (response.status === 200) {
        this._MailId = "";
        this._Message = "";
        this._Loader = false;
        toastr.success(response.message);
      } else {
        this._Loader = false;
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
      this._Loader = false;
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  moveToHome = async (data) => {
    try {
      this._Loader = true;
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this._Loader = false;
        toastr.success(response.message);
      } else {
        this._Loader = false;
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this._Loader = false;
    }
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };
  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };
  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };
  formatYaxisValue = (e) => {
    const chartData = this.state.chartData ? this.state.chartData : {};
    if (
      chartData.yAxes == "PreRiskScore" ||
      chartData.yAxes == "PreWeightedRiskScore" ||
      chartData.yAxes == "Risk Score" ||
      chartData.yAxes == "Prime Risk Score"
    ) {
      return e.value;
    } else if (this.isFloat(e.value)) {
      return "";
    } else {
      return formatNumber(Number(e.value), "##,#");
    }
  };
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
  //POC
  handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    if (this.state.refreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
    if (this._expandFlag === true) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };
  editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const labelContentYvalue = (e) => formatNumber(Number(e.value), "##,#");
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");

    var startDate = moment(chartData.startDate).format("DD-MMM-yyyy");
    var endDate = moment(chartData.endDate).format("DD-MMM-yyyy");
    var y1 = [];
    var y2 = [];
    var y3 = [];
    var y4 = [];
    var y5 = [];
    var y6 = [];
    const toTitleCaseXName = chartData?.xName?.replace(
      /(^\w|\s\w)(\S*)/g,
      (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
    );
    const toTitleCaseYName = chartData?.yName?.replace(
      /(^\w|\s\w)(\S*)/g,
      (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
    );

    if (
      chartData.timeStamp &&
      !chartData.isActionWidget &&
      chartData.axes &&
      chartData.axes.yAxis1
    ) {
      y1 = chartData.axes.yAxis1;
      y2 = chartData.axes.yAxis2;
      y3 = chartData.axes.yAxis3;
      y4 = chartData.axes.yAxis4;
      y5 = chartData.axes.yAxis5;
      y6 = chartData.axes.yAxis6;
    } else if (
      chartData.timeStamp &&
      !chartData.isActionWidget &&
      chartData.timestampAxes &&
      chartData.timestampAxes.yAxis1
    ) {
      y1 = chartData.timestampAxes.yAxis1;
      y2 = chartData.timestampAxes.yAxis2;
      y3 = chartData.timestampAxes.yAxis3;
      y4 = chartData.timestampAxes.yAxis4;
      y5 = chartData.timestampAxes.yAxis5;
      y6 = chartData.timestampAxes.yAxis6;
    }
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else if (
      (chartData.yAxes == "PreWeightedRiskScore" ||
        chartData.yAxes == "Prime Risk Score") &&
      (chartData.isPrimeWorkstreams == false ||
        secureLocalStorage.getItem("isPrime") === false)
    ) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
              : ""}
          </ul>

          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for Tenant or
            Workstream. Please contact administrator.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.isCustomFieldDeleted || chartData.isImpactDeleted) {
      return (
        <div>
          {/* <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                !this.props.isFreezeDS &&
                this.props.selectedDashboard.createdBy == userId)
                 ? (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed1">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              ) : (
                ""
              )
              }
           </ul> */}
          <h4 className="wgTitle">
            Associated Dataset's Impact/Custom fields might been deleted or
            revoked
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.notValidPrimeDataset) {
      return (
        <div>
          {/* <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                !this.props.isFreezeDS &&
                this.props.selectedDashboard.createdBy == userId) ? (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              ) : (
                ""
              )}
           </ul> */}
          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for
            Workstream.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.isTaskModuleDisabled) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
              : ""}
          </ul>
          <h4 className="wgTitle">
            Cannot load report as Task Module settings have been changed for
            Tenant. Please contact administrator.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else {
      return (
        <div id="capture">
          {this.state.visible && (
            <Window
              title={chartData.dataSource}
              onClose={this.closeToggleClose}
              className="statusWindow"
              initialLeft={350}
              initialTop={170}
              initialWidth={1000}
              initialHeight={490}
            >
              <div className="tblCont dataGrids">
                <ViewActionRiskDataset
                  chartData={chartData}
                  isFreezeDS={this.props.isFreezeDS}
                ></ViewActionRiskDataset>
              </div>
            </Window>
          )}
          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}
          {this.props.viewDataSetIcon && (
            <ul className="viewDataset WidgetActions">
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
            </ul>
          )}
          {this.props.flag ? (
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={() => this.editWidgetOpen(chartData)}>
                      <a>
                        <img src={Images.EDITICON} alt="Edit" width="14" />
                      </a>
                    </li>
                  )
                : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Add to home"
                  onClick={() => this.moveToHome(chartData)}
                >
                  <a>
                    <img src={Images.HOME} alt="Download" width="14" />
                  </a>
                </li>
              )}

              <li title="PNG Download" onClick={this.onImageExportClick}>
                <a>
                  <img src={Images.DOWNLOAD} alt="Download" width="14" />
                </a>
              </li>
              <li title="PDF Download" onClick={this.onPDFExportClick}>
                <a>
                  <img src={Images.PDF} alt="Download" width="14" />
                </a>
              </li>
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Share"
                  onClick={() => this.openAddToCart(chartData.widgetId)}
                >
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            // value={this.state.emailId}
                            onChange={(e) =>
                              // this.setState({
                              //   ...this.state,
                              //   emailId: e.target.value,
                              // })
                              (this._MailId = e.target.value)
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            // value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              // this.setState({
                              //   message: e.target.value,
                              // })
                              (this._Message = e.target.value)
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.onPDFExportClick("MAIL")}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions">
              {/* <li
                title="Remove from home"
                onClick={() => this.removeFromHome(chartData)}
              >
                <a>
                  <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
                </a>
              </li> */}
            </ul>
          )}
          {/* <div className="wgHeader">
                <h4>{chartData.widgetName}</h4>
              </div>
              <div className="wgHeader">
                <h5 class="wgTitle">{chartData.title ? chartData.title : ""}</h5>
              </div> */}
          <div id={"c" + chartData.widgetId} key={chartData.title}>
            {/* <small className="createdDate">{CreatedDate}</small> */}

            {chartData.timeStamp ? (
              <div style={{cursor:'default'}}> 
                {chartData.isActionWidget ? (
                  <div>
                    <Chart
                      onRefresh={this.handleChartRefresh}
                      pannable={{ lock: "y" }}
                      zoomable={{
                        mousewheel: { lock: "y" },
                        selection: { lock: "y" },
                      }}
                      ref={(cmp) => (this._chart = cmp)}
                    >
                      <ChartTooltip format="{d}" />
                      <ChartArea background="transparent" margin={(0, 20)} />
                      <ChartTitle
                        text={chartData.title ? chartData.title : ""}
                        color="#b5b5b5"
                      />

                      <ChartLegend
                        position="bottom"
                        align="start"
                        orientation="horizontal"
                        visible={true}
                      />
                      <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                          justified={true}
                          categories={
                            chartData.axes
                              ? chartData.axes.xAxes
                              : chartData.timestampAxes
                              ? chartData.timestampAxes.xAxes
                              : []
                          }
                          title={{ text: toTitleCaseXName }}
                          style={{ width: "100px", overflow: "hidden" }}
                          startAngle={45}
                          color="#919191"
                          labels={{
                            format: "d",
                            rotation: "auto",
                            // content: labelContent
                          }}
                        />
                      </ChartCategoryAxis>
                      <ChartSeries>
                        {chartData.axes.yAxes1 &&
                          chartData.axes.yAxes1.map((item, idx) => (
                            <ChartSeriesItem
                              key={idx}
                              type="column"
                              data={item.data}
                              // name={item.name}
                              tooltip={{ visible: true }}
                              // visible={ true }
                              // color="#28a745"
                              spacing={0.25}
                              // gap={0}
                              // width={100}
                            >
                              <ChartSeriesItemTooltip
                                format={labelContentYvalue}
                              />
                            </ChartSeriesItem>
                          ))}
                      </ChartSeries>
                      <ChartValueAxis skip={4}>
                        <ChartValueAxisItem
                          color="#919191"
                          skip={2}
                          title={{ text: toTitleCaseYName }}
                          labels={{ content: this.formatYaxisValue }}
                        />
                      </ChartValueAxis>
                    </Chart>

                    <h5 className="wgTitle">
                      <span className="snap01"></span> Snapshot 1 : {startDate}
                    </h5>
                    <h5 className="wgTitle">
                      <span className="snap02"></span> Snapshot 2 : {endDate}
                    </h5>
                  </div>
                ) : (
                  <div>
                    <Chart
                      onRefresh={this.handleChartRefresh}
                      pannable={{ lock: "y" }}
                      zoomable={{
                        mousewheel: { lock: "y" },
                        selection: { lock: "y" },
                      }}
                      ref={(cmp) => (this._chart = cmp)}
                    >
                      <ChartTooltip format="{d}" />
                      <ChartArea background="transparent" margin={(0, 20)} />
                      <ChartTitle
                        text={chartData.title ? chartData.title : ""}
                        color="#b5b5b5"
                      />

                      <ChartLegend
                        position="bottom"
                        align="start"
                        orientation="horizontal"
                        visible={true}
                      />
                      <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                          justified={true}
                          categories={
                            chartData.axes
                              ? chartData.axes.xAxes
                              : chartData.timestampAxes
                              ? chartData.timestampAxes.xAxes
                              : []
                          }
                          title={{ text: toTitleCaseXName }}
                          style={{ width: "100px", overflow: "hidden" }}
                          startAngle={45}
                          color="#919191"
                          labels={{
                            format: "d",
                            rotation: "auto",
                            // content: labelContent
                          }}
                        />
                      </ChartCategoryAxis>
                      <ChartSeries>
                        {/* {chartData.yAxes && chartData.yAxes.map((item, idx) => ( */}

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis2?chartData.axes.yAxis2:[]}
                          data={y1}
                          tooltip={{ visible: true }}
                          color="rgb(255, 138, 130)"
                          // spacing={2}
                          // stack={{ group: 'a' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis1?chartData.axes.yAxis1:[]}
                          data={y2}
                          tooltip={{ visible: true }}
                          color="rgb(45, 125, 230)"
                          // spacing={2}
                          // stack={{ group: 'a' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis3?chartData.axes.yAxis3:[]}
                          data={y3}
                          tooltip={{ visible: true }}
                          color="rgb(248, 220, 135)"
                          // spacing={2}
                          // stack={{ group: 'b' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis4?chartData.axes.yAxis4:[]}
                          data={y4}
                          tooltip={{ visible: true }}
                          color="rgb(179, 27, 16)"
                          // spacing={2}
                          // stack={{ group: 'b' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis4?chartData.axes.yAxis4:[]}
                          data={y5}
                          tooltip={{ visible: true }}
                          color="rgb(8, 77, 167)"
                          // spacing={2}
                          // stack={{ group: 'b' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        <ChartSeriesItem
                          type="column"
                          // data={chartData.axes.yAxis4?chartData.axes.yAxis4:[]}
                          data={y6}
                          tooltip={{ visible: true }}
                          color="rgb(223, 170, 10)"
                          // spacing={2}
                          // stack={{ group: 'b' }}
                        >
                          <ChartSeriesItemTooltip format={labelContentYvalue} />
                        </ChartSeriesItem>

                        {/* ))} */}
                      </ChartSeries>
                      <ChartValueAxis skip={4}>
                        <ChartValueAxisItem
                          color="#919191"
                          skip={2}
                          title={{ text: toTitleCaseYName }}
                          labels={{ content: this.formatYaxisValue }}
                        />
                      </ChartValueAxis>
                    </Chart>
                    {chartData.yAxes != "Total Risk Count" &&
                    chartData.yAxes != "Open Risk Count" &&
                    chartData.yAxes != "Closed Risk Count" &&
                    chartData.yAxes != "Total Actions Count" &&
                    chartData.yAxes != "Open Actions Count" &&
                    chartData.yAxes != "Closed Actions Count" &&
                    chartData.yAxes != "Approved Open Actions Count" &&
                    chartData.yAxes != "Unapproved Open Actions Count" &&
                    chartData.yAxes != "% of Fields Completed" ? (
                      <>
                        <h5 className="wgTitle">
                          <span className="unmitigated"></span> {startDate}{" "}
                          {chartData.isOpportunities
                            ? " Unrealised Value"
                            : " Pre-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="currentValueEnd"></span>
                          {startDate}
                          {chartData.isOpportunities
                            ? " Current Value"
                            : " Current-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="mitigated"></span>
                          {startDate}
                          {chartData.isOpportunities
                            ? " Realised Value"
                            : " Post-Mitigated Value"}
                        </h5>

                        <h5 className="wgTitle">
                          <span className="umitigatedend"></span>
                          {endDate}{" "}
                          {chartData.isOpportunities
                            ? " Unrealised Value"
                            : "Pre-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="currentValue"></span>
                          {endDate}{" "}
                          {chartData.isOpportunities
                            ? "Current Value"
                            : " Current-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="mitigatedend"></span>
                          {endDate}{" "}
                          {chartData.isOpportunities
                            ? " Realised Value"
                            : " Post-Mitigated Value"}
                        </h5>
                      </>
                    ) : (
                      <>
                        <h5 className="wgTitle">
                          <span className="snap01"></span> Snapshot 1 :{" "}
                          {startDate}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="snap02"></span> Snapshot 2 :{" "}
                          {endDate}
                        </h5>
                      </>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div>
                {chartData.isActionWidget ||
                chartData.type === "Task" ||
                chartData.type === "TaskAction" ? (
                  <Chart
                    onRefresh={this.handleChartRefresh}
                    pannable={{ lock: "y" }}
                    zoomable={{
                      mousewheel: { lock: "y" },
                      selection: { lock: "y" },
                    }}
                    ref={(cmp) => (
                      (this._chart = cmp), (this._chartTemp = cmp)
                    )}
                  >
                    <ChartTooltip format="{d}" />
                    <ChartArea background="transparent" margin={(0, 20)} />
                    <ChartTitle
                      text={chartData.title ? chartData.title : ""}
                      color="#b5b5b5"
                    />

                    <ChartLegend
                      position="bottom"
                      align="start"
                      orientation="horizontal"
                      visible={true}
                    />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        justified={true}
                        categories={
                          chartData.axes.xAxes ? chartData.axes.xAxes : []
                        }
                        title={{ text: toTitleCaseXName }}
                        style={{ width: "100px", overflow: "hidden" }}
                        startAngle={45}
                        color="#919191"
                        labels={{
                          format: "d",
                          rotation: "auto",
                          // content: labelContent
                        }}
                      />
                    </ChartCategoryAxis>
                    <ChartSeries>
                      {/* {chartData.yAxes && chartData.yAxes.map((item, idx) => ( */}

                      <ChartSeriesItem
                        // key={idx}
                        type="column"
                        data={chartData.axes.yAxes ? chartData.axes.yAxes : []}
                        // name={item.name}
                        tooltip={{ visible: true }}
                        color="#28a745"
                        spacing={2}

                        // gap={0}
                        // width={100}
                      >
                        <ChartSeriesItemTooltip format={labelContentYvalue} />
                      </ChartSeriesItem>
                      {/* ))} */}
                    </ChartSeries>
                    <ChartValueAxis skip={4}>
                      <ChartValueAxisItem
                        color="#919191"
                        skip={2}
                        title={{ text: toTitleCaseYName }}
                        labels={{ content: this.formatYaxisValue }}
                      />
                    </ChartValueAxis>
                  </Chart>
                ) : (
                  <div>
                    {chartData.yAxes === "% of Fields Completed" ||
                    chartData.yAxes === "Total Risk Count" ||
                    chartData.yAxes === "Open Risk Count" ||
                    chartData.yAxes === "Closed Risk Count" ||
                    chartData.yAxes === "Action Count" ? (
                      <Chart
                        onRefresh={this.handleChartRefresh}
                        pannable={{ lock: "y" }}
                        zoomable={{
                          mousewheel: { lock: "y" },
                          selection: { lock: "y" },
                        }}
                        ref={(cmp) => (this._chart = cmp)}
                      >
                        <ChartTooltip format="{d}" />
                        <ChartArea background="transparent" margin={(0, 20)} />
                        <ChartTitle
                          text={chartData.title ? chartData.title : ""}
                          color="#b5b5b5"
                        />

                        <ChartLegend
                          position="bottom"
                          align="start"
                          orientation="horizontal"
                          visible={true}
                        />
                        <ChartCategoryAxis>
                          <ChartCategoryAxisItem
                            justified={true}
                            categories={
                              chartData.axes.xAxes ? chartData.axes.xAxes : []
                            }
                            title={{ text: toTitleCaseXName }}
                            style={{ width: "100px", overflow: "hidden" }}
                            startAngle={45}
                            color="#919191"
                            labels={{
                              format: "d",
                              rotation: "auto",
                              // content: labelContent
                            }}
                          />
                        </ChartCategoryAxis>
                        <ChartSeries>
                          <ChartSeriesItem
                            type="column"
                            data={
                              chartData.axes.yAxes ? chartData.axes.yAxes : []
                            }
                            tooltip={{ visible: true }}
                            color={"rgb(32, 134, 55)"}
                          >
                            <ChartSeriesItemTooltip
                              format={labelContentYvalue}
                            />
                          </ChartSeriesItem>
                        </ChartSeries>
                        <ChartValueAxis skip={4}>
                          <ChartValueAxisItem
                            color="#919191"
                            skip={2}
                            title={{ text: toTitleCaseYName }}
                            labels={{ content: this.formatYaxisValue }}
                          />
                        </ChartValueAxis>
                      </Chart>
                    ) : (
                      <Chart
                        onRefresh={this.handleChartRefresh}
                        pannable={{ lock: "y" }}
                        zoomable={{
                          mousewheel: { lock: "y" },
                          selection: { lock: "y" },
                        }}
                        ref={(cmp) => (this._chart = cmp)}
                      >
                        <ChartTooltip format="{d}" />
                        <ChartArea background="transparent" margin={(0, 20)} />
                        <ChartTitle
                          text={chartData.title ? chartData.title : ""}
                          color="#b5b5b5"
                        />

                        <ChartLegend
                          position="bottom"
                          align="start"
                          orientation="horizontal"
                          visible={true}
                        />
                        <ChartCategoryAxis>
                          <ChartCategoryAxisItem
                            justified={true}
                            categories={
                              chartData.stackedBarchart
                                ? chartData.stackedBarchart.xAxes
                                : chartData.stackedBarchartScore
                                ? chartData.stackedBarchartScore.xAxes
                                : []
                            }
                            title={{ text: toTitleCaseXName }}
                            style={{ width: "100px", overflow: "hidden" }}
                            startAngle={45}
                            color="#919191"
                            labels={{
                              format: "d",
                              rotation: "auto",
                              // content: labelContent
                            }}
                          />
                        </ChartCategoryAxis>
                        <ChartSeries>
                          <ChartSeriesItem
                            // key={idx}
                            type="column"
                            // data={chartData.axes.yAxes ? chartData.axes.yAxes : []}
                            data={
                              chartData.stackedBarchart
                                ? chartData.stackedBarchart.yAxis2
                                : chartData.stackedBarchartScore
                                ? chartData.stackedBarchartScore.yAxis2
                                : []
                            }
                            // name={item.name}
                            tooltip={{ visible: true }}
                            
                            color={
                              chartData.yAxes == "Action Count" ||
                              chartData.yAxes === "% of Fields Completed"
                                ? "rgb(32, 134, 55)"
                                : "rgb(255, 99, 88)"
                            }
                            // spacing={0}
                            // stack={true}
                            // gap={-0.21}
                            // width={100}
                          >
                            <ChartSeriesItemTooltip
                              format={labelContentYvalue}
                            />
                          </ChartSeriesItem>

                          <ChartSeriesItem
                            type="column"
                            data={
                              chartData.stackedBarchart
                                ? chartData.stackedBarchart.yAxis3
                                : chartData.stackedBarchartScore
                                ? chartData.stackedBarchartScore.yAxis3
                                : []
                            }
                            tooltip={{ visible: true }}
                            color={
                              chartData.yAxes == "Action Count" ||
                              chartData.yAxes === "% of Fields Completed"
                                ? "rgb(32, 134, 55)"
                                : "rgb(8, 77, 167)"
                            }
                          >
                            <ChartSeriesItemTooltip
                              format={labelContentYvalue}
                            />
                          </ChartSeriesItem>

                          <ChartSeriesItem
                            // key={idx}
                            type="column"
                            // data={chartData.axes.yAxes ? chartData.axes.yAxes : []}
                            data={
                              chartData.stackedBarchart
                                ? chartData.stackedBarchart.yAxis1
                                : chartData.stackedBarchartScore
                                ? chartData.stackedBarchartScore.yAxis1
                                : []
                            }
                            // name={item.name}
                            tooltip={{ visible: true }}
                            color={
                              chartData.yAxes === "Action Count" ||
                              chartData.yAxes === "% of Fields Completed"
                                ? "rgb(32, 134, 55)"
                                : "rgb(255, 210, 70)"
                            }
                            // spacing={2}
                            // stack={true}
                            // gap={0}
                            // width={100}
                          >
                            <ChartSeriesItemTooltip
                              format={labelContentYvalue}
                            />
                          </ChartSeriesItem>
                        </ChartSeries>
                        <ChartValueAxis skip={4}>
                          <ChartValueAxisItem
                            color="#919191"
                            skip={2}
                            title={{ text: toTitleCaseYName }}
                            labels={{ content: this.formatYaxisValue }}
                          />
                        </ChartValueAxis>
                      </Chart>
                    )}

                    {chartData.yAxes != "Total Risk Count" &&
                    chartData.yAxes != "Open Risk Count" &&
                    chartData.yAxes != "Closed Risk Count" &&
                    chartData.yAxes != "Total Actions Count" &&
                    chartData.yAxes != "Open Actions Count" &&
                    chartData.yAxes != "Closed Actions Count" &&
                    chartData.yAxes != "Approved Open Actions Count" &&
                    chartData.yAxes != "Unapproved Open Actions Count" &&
                    chartData.yAxes != "Action Count" &&
                    chartData.yAxes != "% of Fields Completed" ? (
                      <div>
                        <h5 className="wgTitle">
                          <span className="unmitigated"></span>
                          {chartData.isOpportunities
                            ? " Unrealised Value"
                            : " Pre-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="currentValue"></span>
                          {chartData.isOpportunities
                            ? " Current Value"
                            : " Current-Mitigated Value"}
                        </h5>
                        <h5 className="wgTitle">
                          <span className="mitigated"></span>
                          {chartData.isOpportunities
                            ? " Realised Value"
                            : " Post-Mitigated Value"}
                        </h5>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
            <div className="wgHeader">
              <h4>Dataset: {chartData.dataSource} </h4>
            </div>
            <TextNarrativeExport
              chartData={chartData}
              isHidden={this.state.isHidden}
            />
          </div>
          <ReportUpdate
            chartData={chartData}
            ref="childUpdateWidget"
            updateChartData={this.updateChartData}
          />
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            show={this.state.openPdfTitlePopup}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="addTypeForm">
              <div className="fieldCont">
                <label>Enter Title</label>
                <input
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                  placeholder="Title"
                  value={this.state.title}
                  required
                />
              </div>
              <div className="btnGroup">
                <button
                  disabled={!this.state.title}
                  className="btnPrimary"
                  onClick={this.onPDFExportClick}
                >
                  Export
                </button>
                <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Popup>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>
        </div>
      );
    }
  }
}
